import { Button, Table, Text } from '@mantine/core';
import { Icon, Select, variants } from '@uag/react-core';

import { useConcreteMixtures } from 'hooks';
import { Scenario } from 'models';
import { NumberInput } from './NumberInput';

type ScenarioInputProps = {
    title: string
    value: Scenario
    canDelete?: boolean
    onChange?: (value: Scenario) => void
    onDelete?: () => void
}

export const ScenarioInput = ({ title, value: scenario, canDelete, onChange, onDelete }: ScenarioInputProps) => {
    const { concreteMixtures } = useConcreteMixtures();

    const handleChange = (updated: Partial<Scenario>) => {
        onChange && onChange({ ...scenario, ...updated });
    };

    return (
        <Table.Tr key={scenario.id}>
            <Table.Td className="pr-4">
                <Text className="text-lg-bold min-w-24">
                    {title}
                </Text>
            </Table.Td>
            <Table.Td className="pr-4 min-w-24">
                <NumberInput
                    required={true}
                    unit="°C"
                    value={scenario.ambientTemperature}
                    onChange={(value) => handleChange({ ambientTemperature: value === '' ? undefined : value as number })}
                />
            </Table.Td>
            <Table.Td className="pr-4 min-w-24">
                <NumberInput
                    required={true}
                    unit="°C"
                    value={scenario.freshConcreteTemperature}
                    onChange={(value) => handleChange({ freshConcreteTemperature: value === '' ? undefined : value as number })}
                />
            </Table.Td>
            <Table.Td className="pr-4 w-[576px] min-w-[540px]">
                <Select
                    data={concreteMixtures.map(concreteMixture => concreteMixture.name)}
                    value={scenario.concreteMixture?.name}
                    onChange={(value) => {
                        const concreteMixture = concreteMixtures.find(concreteMixture => concreteMixture.name === value as string);
                        handleChange({
                            concreteMixture,
                            calibrationCurve: concreteMixture?.calibrationCurves[0]
                        });
                    }}
                />
            </Table.Td>
            <Table.Td className="pr-4 w-52 min-w-50">
                <Select
                    data={scenario.concreteMixture?.calibrationCurves.map(calibrationCurve => calibrationCurve.name)}
                    value={scenario.calibrationCurve?.name}
                    onChange={(value) => {
                        if (scenario.concreteMixture !== undefined) {
                            const calibrationCurves = scenario.concreteMixture.calibrationCurves;
                            const calibrationCurve = calibrationCurves.find(calibrationCurve => calibrationCurve.name === value as string);
                            handleChange({ calibrationCurve });
                        }
                    }}
                />
            </Table.Td>
            <Table.Td className="pr-4 min-w-32">
                <NumberInput
                    min={0}
                    required={true}
                    unit="€/m³"
                    value={scenario.concretePrice}
                    onChange={(value) => handleChange({ concretePrice: value === '' ? undefined : value as number })}
                />
            </Table.Td>
            <Table.Td className="!pr-0">
                <Button
                    disabled={!canDelete}
                    variant={variants.button.danger}
                    onClick={() => onDelete && onDelete()}>
                    <Icon icon="delete" size="xl" />
                </Button>
            </Table.Td>
        </Table.Tr>);
};